export enum ContactFormType {
  APPLICATIONS = 'applications',
  RESOURCES = 'resources',
  DEFAULT = 'default',
  PIPELINE_DATA = 'pipeline-data',
  AUTO_DOCKING = 'auto-docking',
  CUSTOMER_CASE = 'customer-case',
  MARITIME = 'maritime',
  NAVY_DEFENCE = 'navy-defence',
  AERONAUTICS = 'aeronautics',
  MOBILE_MACHINES = 'mobile-machines',
  PLATFORM = 'platform',
  CAREERS = 'careers',
  ARTICLES = 'articles',
  SENSORS = 'sensors',
  INDUSTRIES = 'all-industries',
  LANDING_IST = 'landing-intelligent-system-testing',
  LANDING_COUNTER_DRONE = 'landing-counter-drone',
  LANDING_AIRPORT_GROUND_OPS = 'landing-airport-ground-ops',
  LANDING_INTERCEPTOR_USV = 'landing-interceptor-usv',
}

export type ContactFormProps = {
  type?: ContactFormType;
  backgroundColor?: string;
  onClick?: () => void;
};

export type TypeData = {
  title: string;
  description: string;
  buttonLabel: string;
};
